export enum DateOptions {
  ALL = 'All',
  CUSTOM_RANGE = 'Custom Range',
  LAST_MONTH = 'Last Month',
  THIS_MONTH = 'This Month',
  TODAY = 'Today',
  TOMORROW = 'Tomorrow',
  YESTERDAY = 'Yesterday',
}

export enum DatePopperPlacement {
  TOP = 'top',
  BOTTOM = 'bottom',
}
